import { getEnv } from "../env";
import { emptyStorageAdapter } from "./adapters/empty";
import { localStorageAdapter } from "./adapters/local-storage";
import type { StorageAdapter } from "./adapter";
import type { DataTransformer } from "./transformer";

declare global {
  var _storeConfig: StoreConfig;
}

function getDefaultStorageAdapter() {
  return getEnv().persistLocally
    ? localStorageAdapter()
    : emptyStorageAdapter();
}

export interface StoreConfig {
  storageAdapter: StorageAdapter<DataTransformer>;
}
const createStoreConfig = (): StoreConfig => ({
  storageAdapter: getDefaultStorageAdapter(),
});

const storeConfig: StoreConfig = globalThis._storeConfig ?? createStoreConfig();

export const getStoreConfig = () => storeConfig;

export const setStoreConfig = (config: Partial<StoreConfig>) => {
  Object.entries(config).forEach(([key, value]) => {
    if (
      key in storeConfig &&
      Object.hasOwn(storeConfig, key) &&
      typeof value === typeof storeConfig[key as keyof StoreConfig]
    ) {
      (getStoreConfig() as any)[key] = value;
    }
  });
};

// resolved by TX-2363
if (true /* NOT PROD */) {
  globalThis._storeConfig ??= createStoreConfig();
}
